import { c as _c } from "react/compiler-runtime";
import React from "react";
import { thousandize } from "../../../../../util/formatting";
import styles from "../FundraiserWidget.module.scss";
interface SuggestedAmountsProps {
  amounts: number[];
  selectedAmount: number | null;
  currencySymbol: string;
  locale: string;
  onSelect: (amount: number) => void;
}
export const SuggestedAmounts: React.FC<SuggestedAmountsProps> = t0 => {
  const $ = _c(13);
  const {
    amounts,
    selectedAmount,
    currencySymbol,
    locale,
    onSelect
  } = t0;
  let t1;
  if ($[0] !== amounts || $[1] !== currencySymbol || $[2] !== locale || $[3] !== onSelect || $[4] !== selectedAmount) {
    let t2;
    if ($[6] !== currencySymbol || $[7] !== locale || $[8] !== onSelect || $[9] !== selectedAmount) {
      t2 = sum => <button key={sum} type="button" onClick={() => onSelect(sum)} className={[styles["donation-widget__input-group__suggested-sums__button"], selectedAmount === sum ? styles["donation-widget__input-group__suggested-sums__button--active"] : ""].join(" ")} data-cy={`fundraiser-suggested-${sum}`}>{thousandize(sum, locale)} {currencySymbol}</button>;
      $[6] = currencySymbol;
      $[7] = locale;
      $[8] = onSelect;
      $[9] = selectedAmount;
      $[10] = t2;
    } else {
      t2 = $[10];
    }
    t1 = amounts.map(t2);
    $[0] = amounts;
    $[1] = currencySymbol;
    $[2] = locale;
    $[3] = onSelect;
    $[4] = selectedAmount;
    $[5] = t1;
  } else {
    t1 = $[5];
  }
  let t2;
  if ($[11] !== t1) {
    t2 = <div className={styles["donation-widget__input-group__suggested-sums"]} data-cy="fundraiser-suggested-amounts">{t1}</div>;
    $[11] = t1;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  return t2;
};